/* eslint-disable max-classes-per-file */
import ConsoleLogger from './ConsoleLogger';

class GaLogger extends ConsoleLogger {
  constructor(doc, win, adInstance, placementId) {
    super(adInstance);
    this.doc = doc;
    this.win = win;
    this.adInstance = adInstance;
    this.placementId = placementId;
    GaLogger.initGA(win, doc);
    this.pvId = adInstance.pvId;
    this.campaignId = adInstance.campaignID;
    this.loggedEvents = [];

    const { dabuPlacementId = '' } = adInstance.dataset;
    const adPlacements = dabuPlacementId.split(',');
    // Event- dataLayer-initialized to be triggered only once for Ad blocks
    if (Array.isArray(adPlacements) && adPlacements.length && adPlacements[0] === placementId) {
      this.logEvent(this.getInitPayload());
    }
  }

  debug(...args) {
    if (this.adInstance.debugMode) {
      console.log(
        '%c Ad Placement: %s, Message: ',
        'background: #222; color: #ebba34',
        this.placementId || this.adInstance.dataset.dabuPlacementId,
        ...args,
      );
    }
  }

  recordEvent(eventType) {
    this.loggedEvents.push(eventType);
  }

  getInitPayload() {
    const {
      dataset, campaignID, sourceUrl, version, ueId,
    } = this.adInstance;

    return {
      event: 'dataLayer-initialized',
      adDimensions: `${dataset.dabuWidth}x${dataset.dabuHeight}`,
      appName: dataset.adType,
      campaignID,
      category: dataset.dabuCategory,
      eventType: 'Impression',
      eventDate: new Date().toISOString(),
      href: this.win.location.href,
      pageViewId: this.pvId,
      queryTerm: dataset.title, // TODO: how do we do this
      sourceURL: sourceUrl,
      ueid: ueId,
      version,
    };
  }

  logEvent(payload) {
    this.win.dataLayerDabu = this.win.dataLayerDabu || [];
    this.win.dataLayerDabu.push(payload);
    this.recordEvent(`${payload.event}|${payload.eventType}`);
  }

  static initGA(w, d) {
    // This is google's minified GA initialization script, but with better whitespace.
    // The ONLY thing you should ever modify in this function is the value of `i`
    // (unless you have a _very_ good reason).
    const s = 'script';
    const l = 'dataLayerDabu';
    const i = 'GTM-T98V9FX';
    // eslint-disable-next-line
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  }

  getInViewPayload(isFirstAdBlock) {
    return {
      event: 'ad-in-view',
      eventType: 'Action-InView',
      eventDate: new Date().toISOString(),
      zone: isFirstAdBlock ? 'top' : 'bottom',
    };
  }

  getClickPayload(index, keyword, lpUrl, isFirstAdBlock) {
    return {
      event: 'ad-click',
      eventType: 'Action-Click',
      ordinal: index,
      keyword,
      eventDate: new Date().toISOString(),
      'gtm.elementUrl': lpUrl,
      zone: isFirstAdBlock ? 'top' : 'bottom',
    };
  }
}

export default GaLogger;
